import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Field, ModeFieldDate, TypeField, validatorCustom } from '@ascschool/interface/form/field';
import { NationnalityService } from '@ascschool/services/category/nationnality.service';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-phieu-hoi-gd-nkt',
  templateUrl: './phieu-hoi-gd-nkt.component.html',
  styleUrls: ['./phieu-hoi-gd-nkt.component.scss']
})
export class PhieuHoiGdNktComponent implements OnInit {
  checkbox = false;
  checkbox1 = false;
  checkbox2 = false;
  checkbox3 = false;
  checkbox4 = false;
  checkbox5 = false;
  checkbox6 = false;
  checkbox7 = false;
  checkbox8 = false;
  checkbox9 = false;
  checkbox10 = false;
  checkbox11 = false;
  checkbox12 = false;
  checkbox13 = false;
  checkbox14 = false;
  checkbox15 = false;
  checkbox16 = false;
  checkbox17 = false;
  checkbox18 = false;
  checkbox19 = false;
  checkbox20 = false;
  formFeildItems: Field[]
  getnatioNalityACFn: (value: any) => Observable<any>;
  natioNalitySubscription: any;
  // natioNalityControl = this.validateForm.controls.nationalityId;
  eventsSubject: Subject<void> = new Subject<void>();
  emitEventToChild() {
    this.eventsSubject.next();
  }
  
  validatorCustom: validatorCustom[] = [
    new validatorCustom(Validators.required, 'require', 'Vui lòng nhập trường bắt buộc'),
    new validatorCustom(Validators.max(200), 'max', 'Số lớn nhất không quá 200 '),
  ]
  

  loadnatioNality() {
    this.getnatioNalityACFn = (value: any) => this.nationnalityService.getNationnalitySelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.nationalityName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    
  }
  inputCode = [];
  gender = 'Nam';
  relationship = "";
  relationship2 = "";
  relationship3 = "";
  gender2 = '';
  gender3 = '';
  gender4 = '';
  gender5 = '';
  gender6 = '';
  gender7 = '';
  gender8 = '';
  gender9 = '';
  gender10 = '';
  gender11 = '';
  gender12 = '';
  gender13 = '';
  gender14 = '';
  gender15 = '';
  gender16 = '';
  gender17 = '';
  gender18 = '';
  gender19 = '';
  gender20 = '';
  gender21 = '';
  gender22 = '';
  gender100 = '';
  gender101 = '';
  gender102 = '';
  gender103 = '';
  gender104 = '';
  gender105 = '';
  gender106 = '';
  gender107 = '';
  gender108 = '';
  gender109 = '';
  gender110 = '';
  listOfData = [
    {
    stt: 1,
    type : "Phát triển hể chất – vận động",
    isTrain : false,
    isNeed : false,
    },
    {
    stt: 2,
    type : "Phát triển Nhận thức/học tập",
    isTrain : false,
    isNeed : false,
    },
    {
    stt: 3,
    type : "Phát triển Ngôn ngữ - Giao tiếp",
    isTrain : false,
    isNeed : false,
    },
    {
    stt: 4,
    type : "GD kĩ năng Tự phục vụ",
    isTrain : false,
    isNeed : false,
    },
    {
    stt: 5,
    type : "Quản lí Hành vi",
    isTrain : false,
    isNeed : false,
    },
  ];
  constructor(
    private nationnalityService: NationnalityService,
  ) { }

  ngOnInit() {
    let num = 10;
    for(let i = 0; i < num; i++){
      this.inputCode.push(i);
    }
    this.loadnatioNality()
    this.formFeildItems = [
      new Field('Tỉnh thành', TypeField.INPUT, 'tinhthanh', 'Nhập tỉnh thành', true, null, 6, null,null,null, this.validatorCustom),
      new Field('Số Tỉnh thành 2', TypeField.NUMBER, 'tinhthanh2', 'Nhập số tỉnh thành', true, null, 6, null,null,null, this.validatorCustom),
      new Field('Chọn ngày tháng', TypeField.DATETIME, 'tinhthanh4', 'Chọn ngày tháng', true, null, 6, null, ModeFieldDate.YEAR),
      new Field('Tỉnh thành 3', TypeField.SELECT, 'tinhthanh3', 'Chọn tỉnh thành 3', true, null, 6, null, null, [{lable: "Lai Châu", key:"1"},{lable: "Hà Nội", key:"2"}]),
      new Field('Giới tính', TypeField.RADIO, 'tinhthanh7', 'Giới tính', true, null, 6, -1, null, [{lable: "Nam", key: 1 },{lable: "Nữ", key: 0 },{lable: "Tất cả", key:-1}]),
      new Field('Là người dân tộc', TypeField.CHECKBOX, 'tinhthanh6', 'Giới tính', true, null, 6, -1, null, ),
      new Field('AutoComplete', TypeField.SELECT_AUTOCOMPLETE, 'autoComplete', 'AutoComplete', true, null, 6, null, null, null,null, this.getnatioNalityACFn),
    ];
  }
}
